<template lang='pug'>
  div(:class='$style[`cc-topbar-score`]')
    transition(name='animate-score-slide-up-fade' mode='out-in')
      div(v-if='showAnimate && target === `hp`' :class='$style[`cc-topbar-score-content`]')
        div(:class='[$style[`cc-topbar-score-wrap`], $style[`cc-topbar-score-hp`]]')
          IconHp(:size='34')
          strong {{ `${grade.hp}` }}
          span!= '經驗值'

      div(v-else-if='showAnimate && target === `point`' :class='$style[`cc-topbar-score-content`]')
        div(v-if='grade.point === `limit`' :class='[$style[`cc-topbar-score-wrap`], $style[`cc-topbar-score-ccoin`]]')
          IconCcoin(:size='34')
          //- strong!= '每日限領1次C幣'
          span!= '每日限領1次C幣'
        div(v-else :class='[$style[`cc-topbar-score-wrap`], $style[`cc-topbar-score-ccoin`]]')
          IconCcoin(:size='34')
          strong {{ `${grade.point}` }}
          span!= '幣'

      div(v-else-if='showAnimate && target === `both`' :class='$style[`cc-topbar-score-content`]')
        div(:class='[$style[`cc-topbar-score-wrap`], $style[`cc-topbar-score-hp`]]')
          IconHp(:size='34')
          strong {{ `${grade.hp}` }}
          span!= '經驗值'

        div(:class='[$style[`cc-topbar-score-wrap`], $style[`cc-topbar-score-ccoin`]]')
          IconCcoin(:size='34')
          strong {{ `${grade.point}` }}
          span!= '幣'


</template>

<script>
// import { mapActions, mapMutations, mapGetters } from 'vuex';
// import * as jwt_decode from 'jwt-decode';
import IconCcoin from '../../icon/Ccoin';
import IconHp from '../../icon/Hp';

// import IconDonate from '../../icon/Donate';

import {
} from '../../../js/restapi';

export default {
  components: {
    IconCcoin,
    IconHp,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '',
    },
    grade: {
      type: Object,
      default: () => {
        return {
          hp: '',
          point: '',
        };
      },
    },
  },

  data() {
    return {
      showAnimate: false,
    };
  },

  mounted() {
    this.showAnimate = this.active;
  },

  // methods: {
  // ...mapActions({
  //   changeLoginStatus: 'user/userLoginMember',
  //   changeUserPanel: 'user/changeTopBarUserPanelFocus',
  // }),

  // ...mapMutations({
  //   changeUserScoreStatus: 'user/TOPBAR_USER_SCORE',
  // }),
  // },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     authJwtToken: 'user/exportUserJwtToken',
  //     loginProfile: 'user/exportUserProfile',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginHashCode: 'user/exportUserHashCode',
  //   }),
  // },
};

</script>

<style module lang='scss'>
   @import '../../../sass/component/page/topbar/scoreAnimate.scss';
</style>
